import { EnumOption } from "./enum-option"

export const FNSalutation = {
    Mr: 0,
    Ms: 1,
    Mrs: 2,
    Miss: 3,
    Mx: 4,
    Dr: 5,
    Prof: 6,
    Hon: 7,
    Rev: 8,
}

export const FNSalutationList: EnumOption[] = [
    { value: FNSalutation.Mr, label: 'Mr.' },
    { value: FNSalutation.Ms, label: 'Ms.' },
    { value: FNSalutation.Mrs, label: 'Mrs.' },
    { value: FNSalutation.Miss, label: 'Miss' },
    { value: FNSalutation.Mx, label: 'Mx.' },
    { value: FNSalutation.Dr, label: 'Dr.' },
    { value: FNSalutation.Prof, label: 'Prof.' },
    { value: FNSalutation.Hon, label: 'Hon.' },
    { value: FNSalutation.Rev, label: 'Rev.' },
]
